import { BaseApiManager, ApiResponse } from './BaseApiManager';

export class BooksApiManager extends BaseApiManager {
  private static instance: BooksApiManager;

  private constructor() {
    super();
  }

  public static getInstance(): BooksApiManager {
    if (!BooksApiManager.instance) {
      BooksApiManager.instance = new BooksApiManager();
    }
    return BooksApiManager.instance;
  }

  public async createBooksOutput(data: any): Promise<ApiResponse<any>> {
    return this.request('/books/output', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  public async createBooksToUse(data: any): Promise<ApiResponse<any>> {
    return this.request('/books/to-use', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  public async createCompleteBook(data: any): Promise<ApiResponse<any>> {
    return this.request('/books/complete', {
      method: 'POST',
      body: JSON.stringify(data),
    });
  }

  public async getBooksOutputById(userId: number, id: number): Promise<ApiResponse<any>> {
    return this.request(`/books/output/${userId}/${id}`);
  }

  public async getBooksToUseById(userId: number, id: number): Promise<ApiResponse<any>> {
    return this.request(`/books/to-use/${userId}/${id}`);
  }

  public async getBooksCompleteById(userId: number, booksOutputId: number): Promise<ApiResponse<any>> {
    return this.request(`/books/complete/${userId}/${booksOutputId}`);
  }

  public async getBooksLastCompleteByUserId(userId: number): Promise<ApiResponse<any>> {
    return this.request(`/core/books/complete/${userId}`);
  }
}
